module.exports = __webpack_public_path__ + "static/media/complete.5b5933b4.svg";